module.exports = __webpack_public_path__ + "static/img/Frankie-Dadzie.1423fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/vantage/Frankie-Dadzie.jpg
// module id = sYlO
// module chunks = 0